require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./perceptions-of-safety-in-portland.json") })
        }
      }, "path---perceptions-of-safety-in-portland");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---perceptions-of-safety-in-portland!./.cache/json/perceptions-of-safety-in-portland.json
// module id = 949
// module chunks = 231608221292675